import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import team1 from '../assets/images/team1.jpg';
import team2 from '../assets/images/team2.jpg';
import team3 from '../assets/images/team3.jpg';
import team4 from '../assets/images/team4.jpg';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "100px",
        paddingBottom: "100px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg1,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    box: {
        "&:hover": {
            "& h3": {
                color: theme.palette.primary.main,
                //letterSpacing: 1,
            },
            "& img": {
                opacity: 0.5
            }
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom: "10px"
        },
    },
    serviceTitle: {
        lineHeight: 1.5,
        paddingLeft: "25px",
        paddingRight: "25px",
        marginBottom: "10px",
        letterSpacing: 0,
        fontSize: "1.5rem",
        fontWeight: 600,
        transition: "0.5s",
        textTransform: "capitalize",
    },
    serviceSubtitle: {
        color: theme.palette.primary.main,
        marginTop: "10px",
        lineHeight: 1.5,
        paddingLeft: "25px",
        paddingRight: "25px",
        marginBottom: "10px",
        letterSpacing: 0,
        fontSize: "1.2rem",
        fontWeight: 300,
        transition: "0.5s",
        textTransform: "capitalize",
    }
}))



export default function Team() {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <React.Fragment >
            <Grid container direction="column" className={classes.container} id="team">

                <Grid item >
                    <Typography variant="h2" gutterBottom>GROUP</Typography>
                </Grid>
                <Grid item >
                    <Typography variant="h1" paragraph>Our Professional Team</Typography>
                </Grid>

                <Grid item container direction="row" justify="center" style={{ marginTop: "50px" }}>

                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={team1} alt="team"
                                style={{
                                    width: "100%",
                                    transition: "0.5s",
                                    userSelect: "none",
                                    marginTop: "10px",
                                    border: `1px solid ${theme.palette.common.gray}`,
                                }}
                            />
                            <Typography variant="h3" className={classes.serviceTitle} style={{ marginTop: "10px", }}>
                                Sid
                                <br />
                                Rezaei
                            </Typography>
                            <Typography variant="h2" className={classes.serviceSubtitle}>
                                CEO
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6} style={{ marginTop: matchesSM ? "-50px" : "-25px" }}>
                        <Grid item container direction="column" className={classes.box} >
                            <img src={team2} alt="team"
                                style={{
                                    width: "100%",
                                    transition: "0.5s",
                                    userSelect: "none",
                                    marginTop: "10px",
                                    border: `1px solid ${theme.palette.common.gray}`,
                                }}
                            />
                            <Typography variant="h3" className={classes.serviceTitle} style={{ marginTop: "10px", }}>
                                Nikzad
                                <br />
                                Seraji
                            </Typography>
                            <Typography variant="h2" className={classes.serviceSubtitle}>
                                COO
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6} style={{ paddingTop: "50px" }}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={team3} alt="team" style={{
                                width: "100%",
                                transition: "0.5s",
                                userSelect: "none",
                                marginTop: "10px",
                                border: `1px solid ${theme.palette.common.gray}`,

                            }} />
                            <Typography variant="h3" className={classes.serviceTitle} style={{ marginTop: "10px", }}>
                                Rasa
                                <br />
                                Moradi
                            </Typography>
                            <Typography variant="h2" className={classes.serviceSubtitle}>
                                Architect and Designer
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={team4} alt="team" style={{
                                width: "100%",
                                transition: "0.5s",
                                userSelect: "none",
                                marginTop: "10px",
                                border: `1px solid ${theme.palette.common.gray}`,
                            }}
                            />
                            <Typography variant="h3" className={classes.serviceTitle} style={{ marginTop: "10px", }}>
                                Farzan
                                <br />
                                Moradi
                            </Typography>
                            <Typography variant="h2" className={classes.serviceSubtitle}>
                                CTO
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </React.Fragment>

    );
}
